import { WidthFull, WidthNormal } from '@mui/icons-material'
import {
  ToggleButton,
  ToggleButtonGroup,
  type ToggleButtonGroupProps,
} from '@mui/material'
import type { SearchResultWidth } from '../../types'

type Props = ToggleButtonGroupProps & {
  value: SearchResultWidth
}

export const ViewWidth = (props: Props) => {
  return (
    <ToggleButtonGroup {...props} exclusive color="info">
      <ToggleButton value="narrow">
        <WidthNormal />
      </ToggleButton>
      <ToggleButton value="wide">
        <WidthFull />
      </ToggleButton>
    </ToggleButtonGroup>
  )
}
